import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  u: () => (/* binding */ IconBenefitsRecycledmaterial)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/IconBenefitsRecycledmaterial.tsx


const IconBenefitsRecycledmaterial = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-benefits-recycledmaterial-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("title", { children: 'Recycled Material Icon' }), (0,jsx_runtime.jsx)("desc", { children: 'Created with Sketch.' }), (0,jsx_runtime.jsx)("defs", {}), (0,jsx_runtime.jsx)("g", Object.assign({ id: "Spots-Flow", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Icons-", transform: "translate(-507.000000, -574.000000)", fill: "#00285E" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Recycled-Material-Icon-", transform: "translate(508.000000, 574.000000)" }, { children: (0,jsx_runtime.jsxs)("g", Object.assign({ id: "Recycled-Material-Icon" }, { children: [(0,jsx_runtime.jsx)("g", Object.assign({ id: "Moisture-Wicking-Icon-", stroke: "#00174F", strokeWidth: 0.5 }, { children: (0,jsx_runtime.jsx)("path", { d: "M15.0018463,1.11084871 C14.9773314,1.11084871 14.9535593,1.11084871 14.9283015,1.11084871 C6.94385832,1.15096261 0.480084618,7.67838616 0.519457104,15.6625387 C0.559572468,23.6221772 7.04786112,30.0708586 14.9988748,30.0708586 C15.0226469,30.0708586 15.0479047,30.0708586 15.0716767,30.0708586 C18.9398378,30.0515445 22.5687925,28.5272162 25.2906942,25.7794138 C28.0118531,23.0308685 29.4998359,19.3871889 29.4805211,15.5191686 C29.4612063,11.6511483 27.9375654,8.02306859 25.1889201,5.30126594 C22.4581038,2.59729169 18.8425209,1.11084871 15.0018463,1.11084871 Z M14.9988748,30.5908537 C6.76185343,30.5915965 0.0403013706,23.9111458 0.000186006853,15.6655101 C-0.040672234,7.39387458 6.65487913,0.631710412 14.92533,0.590853659 L15.0018463,0.590853659 C18.9806961,0.590853659 22.7255396,2.13078185 25.5544156,4.93206946 C28.4018636,7.75118546 29.9804774,11.5100068 29.9997922,15.5169401 C30.0205928,19.5231305 28.4791228,23.2975517 25.6599041,26.144896 C22.8406855,28.9922403 19.0809845,30.5707967 15.0746483,30.5908537 L14.9988748,30.5908537 Z", id: "Fill-19" }) })), (0,jsx_runtime.jsxs)("g", Object.assign({ id: "Content-", transform: "translate(5.000000, 7.000000)" }, { children: [(0,jsx_runtime.jsx)("path", { d: "M4.03503704,15.160663 C3.94425926,15.160663 3.85559259,15.1135148 3.80703704,15.0290704 C3.37777778,14.2873667 3.37777778,13.3662185 3.80703704,12.6252185 L4.42348148,11.5555889 C4.49596296,11.4296259 4.65781481,11.3859963 4.78377778,11.4591815 C4.91044444,11.531663 4.95407407,11.6928111 4.88088889,11.8194778 L4.26374074,12.8891074 C3.92948148,13.4675519 3.92948148,14.1860333 4.26303704,14.7651815 C4.33692593,14.8911444 4.2932963,15.0522926 4.16662963,15.1254778 C4.12581481,15.1494037 4.08007407,15.160663 4.03503704,15.160663", id: "Fill-4" }), (0,jsx_runtime.jsx)("path", { d: "M1.5857963,6.36436667 L2.48512963,6.8837 C2.6117963,6.95618148 2.65542593,7.11803333 2.58224074,7.2439963 L1.79338889,8.61058889 C1.45912963,9.18903333 1.45912963,9.90751481 1.79338889,10.4859593 L4.26409259,14.7651815 C4.59694444,15.3429222 5.21972222,15.7025148 5.88753704,15.7025148 L9.0155,15.7025148 L9.0155,11.9510704 L4.65183333,11.9510704 C4.55824074,11.9510704 4.47098148,11.9011074 4.42312963,11.8194778 C4.37668519,11.7378481 4.37668519,11.6372185 4.42312963,11.5555889 L5.82983333,9.11936667 C5.90372222,8.9919963 6.06627778,8.95047778 6.19083333,9.02295926 L7.09016667,9.54229259 L5.14724074,6.55295926 L1.5857963,6.36436667 Z M9.27938889,16.2302926 L5.88753704,16.2302926 C5.03183333,16.2302926 4.23453704,15.7700704 3.80598148,15.0290704 L1.33598148,10.7498481 C0.90812963,10.0088481 0.90812963,9.0884037 1.33598148,8.3467 L1.99253704,7.20881111 L0.369092593,6.27077407 C0.262833333,6.21025556 0.21287037,6.08429259 0.248055556,5.96747778 C0.282537037,5.85066296 0.397240741,5.77044074 0.514759259,5.77888519 L5.30838889,6.03292222 C5.39283333,6.03784815 5.47024074,6.08218148 5.51598148,6.15255185 L8.13305556,10.1770333 C8.1992037,10.2790704 8.18724074,10.4141815 8.1035,10.5021444 C8.01905556,10.5915148 7.88535185,10.6098111 7.7797963,10.5492926 L6.15564815,9.61195926 L5.10924074,11.4232926 L9.27938889,11.4232926 C9.42505556,11.4232926 9.54327778,11.5415148 9.54327778,11.6871815 L9.54327778,15.9664037 C9.54327778,16.1120704 9.42505556,16.2302926 9.27938889,16.2302926 Z", id: "Fill-6" }), (0,jsx_runtime.jsx)("path", { d: "M16.5924185,11.9517037 L15.3574185,11.9517037 C15.2117519,11.9517037 15.0935296,11.8334815 15.0935296,11.6878148 C15.0935296,11.5421481 15.2117519,11.4239259 15.3574185,11.4239259 L16.5924185,11.4239259 C17.2602333,11.4239259 17.8830111,11.0643333 18.2165667,10.4858889 C18.2904556,10.3599259 18.4516037,10.317 18.576863,10.3894815 C18.7035296,10.461963 18.7471593,10.6231111 18.6739741,10.7497778 C18.2461222,11.4914815 17.4488259,11.9517037 16.5924185,11.9517037", id: "Fill-8" }), (0,jsx_runtime.jsx)("path", { d: "M10.6638556,13.8271444 L12.280263,17.0050704 L12.280263,15.9664037 C12.280263,15.820737 12.3984852,15.7025148 12.5441519,15.7025148 L14.1225593,15.7025148 C14.7896704,15.7025148 15.4124481,15.3429222 15.7474111,14.7644778 L18.2160037,10.4859593 C18.550263,9.90751481 18.550263,9.18903333 18.2160037,8.61058889 L16.6523741,5.90132963 L13.4047815,7.7767 L15.586263,11.5555889 C15.6334111,11.6379222 15.6334111,11.7378481 15.586263,11.8194778 C15.5391148,11.9018111 15.4518556,11.9517741 15.3575593,11.9517741 L12.5441519,11.9517741 C12.3984852,11.9517741 12.280263,11.8335519 12.280263,11.6878852 L12.280263,10.6492185 L10.6638556,13.8271444 Z M12.5441519,18.3695519 C12.446337,18.3695519 12.3541519,18.3153667 12.3091148,18.2252926 L10.1325593,13.9467741 C10.0938556,13.8714778 10.0938556,13.7828111 10.1325593,13.7075148 L12.3091148,9.4289963 C12.3633,9.31921852 12.4885593,9.26292222 12.6060778,9.29177407 C12.7243,9.31992222 12.8080407,9.42618148 12.8080407,9.54792222 L12.8080407,11.4239963 L14.9008556,11.4239963 L12.8150778,7.81258889 C12.7805963,7.75207037 12.7707444,7.67958889 12.7890407,7.61203333 C12.8066333,7.54447778 12.8509667,7.48677407 12.9114852,7.45158889 L16.6171889,5.31232963 C16.740337,5.23984815 16.9028926,5.28207037 16.9781889,5.40944074 L18.6741148,8.3467 C19.101263,9.0884037 19.101263,10.0088481 18.6741148,10.7498481 L16.2041148,15.0290704 C15.7755593,15.7700704 14.9775593,16.2302926 14.1225593,16.2302926 L12.8080407,16.2302926 L12.8080407,18.105663 C12.8080407,18.2274037 12.7243,18.333663 12.6060778,18.3625148 C12.5849667,18.3674407 12.5645593,18.3695519 12.5441519,18.3695519 Z", id: "Fill-10" }), (0,jsx_runtime.jsx)("path", { d: "M10.004837,2.68054815 C9.91405926,2.68054815 9.82539259,2.6334 9.77613333,2.54895556 L9.15828148,1.47862222 C8.82472593,0.900881481 8.20194815,0.541288889 7.53413333,0.541288889 C7.38846667,0.541288889 7.27024444,0.423066667 7.27024444,0.2774 C7.27024444,0.131733333 7.38846667,0.0135111111 7.53413333,0.0135111111 C8.38983704,0.0135111111 9.18783704,0.473733333 9.61568889,1.21473333 L10.2335407,2.28506667 C10.3067259,2.41102963 10.2630963,2.57217778 10.1364296,2.64536296 C10.0956148,2.66928889 10.0498741,2.68054815 10.004837,2.68054815", id: "Fill-12" }), (0,jsx_runtime.jsx)("path", { d: "M4.34698889,4.18795185 L7.59458148,6.06332222 L9.77606296,2.28443333 C9.87106296,2.12117407 10.1384704,2.12117407 10.2334704,2.28443333 L11.6401741,4.72135926 C11.6746556,4.78187778 11.6845074,4.85365556 11.6662111,4.92121111 C11.6486185,4.98947037 11.6042852,5.04647037 11.5437667,5.08165556 L10.6437296,5.60098889 L14.2051741,5.41169259 L16.1488037,2.42306296 L15.2487667,2.9423963 C15.1882481,2.97687778 15.115063,2.98602593 15.0489148,2.96913704 C14.9806556,2.95084074 14.9229519,2.90650741 14.8877667,2.84598889 L14.0989148,1.47869259 C13.766063,0.900951852 13.1432852,0.541359259 12.4754704,0.541359259 L7.53406296,0.541359259 C6.86695185,0.541359259 6.24417407,0.900951852 5.90991481,1.4793963 L4.34698889,4.18795185 Z M7.69169259,6.68750741 C7.64524815,6.68750741 7.60021111,6.67554444 7.5593963,6.65232222 L3.8543963,4.51306296 C3.72772963,4.43987778 3.6848037,4.27872963 3.75728519,4.15276667 L5.45250741,1.2148037 C5.88176667,0.473803704 6.67906296,0.0135814815 7.53406296,0.0135814815 L12.4754704,0.0135814815 C13.3311741,0.0135814815 14.1284704,0.473803704 14.5570259,1.2148037 L15.2135815,2.3533963 L16.8377296,1.41606296 C16.9432852,1.35484074 17.0769889,1.37313704 17.1614333,1.46250741 C17.2451741,1.55117407 17.2578407,1.68558148 17.1909889,1.78832222 L14.5739148,5.8121 C14.5281741,5.88247037 14.4507667,5.92750741 14.3663222,5.93172963 L9.57269259,6.18647037 C9.45165556,6.19421111 9.34047037,6.1153963 9.30598889,5.99787778 C9.2708037,5.88106296 9.32076667,5.7551 9.42702593,5.69458148 L11.0504704,4.75654444 L10.0047667,2.94450741 L7.9203963,6.55591481 C7.88521111,6.61643333 7.82750741,6.66076667 7.75995185,6.67906296 C7.73743333,6.68469259 7.71421111,6.68750741 7.69169259,6.68750741 Z", id: "Fill-14" })] }))] })) })) })) }))] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-benefits-recycledmaterial-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("title", { children: 'Recycled Material Icon' }), (0,jsx_runtime.jsx)("desc", { children: 'Created with Sketch.' }), (0,jsx_runtime.jsx)("defs", {}), (0,jsx_runtime.jsx)("g", Object.assign({ id: "Spots-Flow", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Icons-", transform: "translate(-507.000000, -574.000000)", fill: "#00285E" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Recycled-Material-Icon-", transform: "translate(508.000000, 574.000000)" }, { children: (0,jsx_runtime.jsxs)("g", Object.assign({ id: "Recycled-Material-Icon" }, { children: [(0,jsx_runtime.jsx)("g", Object.assign({ id: "Moisture-Wicking-Icon-", stroke: "#00174F", strokeWidth: 0.5 }, { children: (0,jsx_runtime.jsx)("path", { d: "M15.0018463,1.11084871 C14.9773314,1.11084871 14.9535593,1.11084871 14.9283015,1.11084871 C6.94385832,1.15096261 0.480084618,7.67838616 0.519457104,15.6625387 C0.559572468,23.6221772 7.04786112,30.0708586 14.9988748,30.0708586 C15.0226469,30.0708586 15.0479047,30.0708586 15.0716767,30.0708586 C18.9398378,30.0515445 22.5687925,28.5272162 25.2906942,25.7794138 C28.0118531,23.0308685 29.4998359,19.3871889 29.4805211,15.5191686 C29.4612063,11.6511483 27.9375654,8.02306859 25.1889201,5.30126594 C22.4581038,2.59729169 18.8425209,1.11084871 15.0018463,1.11084871 Z M14.9988748,30.5908537 C6.76185343,30.5915965 0.0403013706,23.9111458 0.000186006853,15.6655101 C-0.040672234,7.39387458 6.65487913,0.631710412 14.92533,0.590853659 L15.0018463,0.590853659 C18.9806961,0.590853659 22.7255396,2.13078185 25.5544156,4.93206946 C28.4018636,7.75118546 29.9804774,11.5100068 29.9997922,15.5169401 C30.0205928,19.5231305 28.4791228,23.2975517 25.6599041,26.144896 C22.8406855,28.9922403 19.0809845,30.5707967 15.0746483,30.5908537 L14.9988748,30.5908537 Z", id: "Fill-19" }) })), (0,jsx_runtime.jsxs)("g", Object.assign({ id: "Content-", transform: "translate(5.000000, 7.000000)" }, { children: [(0,jsx_runtime.jsx)("path", { d: "M4.03503704,15.160663 C3.94425926,15.160663 3.85559259,15.1135148 3.80703704,15.0290704 C3.37777778,14.2873667 3.37777778,13.3662185 3.80703704,12.6252185 L4.42348148,11.5555889 C4.49596296,11.4296259 4.65781481,11.3859963 4.78377778,11.4591815 C4.91044444,11.531663 4.95407407,11.6928111 4.88088889,11.8194778 L4.26374074,12.8891074 C3.92948148,13.4675519 3.92948148,14.1860333 4.26303704,14.7651815 C4.33692593,14.8911444 4.2932963,15.0522926 4.16662963,15.1254778 C4.12581481,15.1494037 4.08007407,15.160663 4.03503704,15.160663", id: "Fill-4" }), (0,jsx_runtime.jsx)("path", { d: "M1.5857963,6.36436667 L2.48512963,6.8837 C2.6117963,6.95618148 2.65542593,7.11803333 2.58224074,7.2439963 L1.79338889,8.61058889 C1.45912963,9.18903333 1.45912963,9.90751481 1.79338889,10.4859593 L4.26409259,14.7651815 C4.59694444,15.3429222 5.21972222,15.7025148 5.88753704,15.7025148 L9.0155,15.7025148 L9.0155,11.9510704 L4.65183333,11.9510704 C4.55824074,11.9510704 4.47098148,11.9011074 4.42312963,11.8194778 C4.37668519,11.7378481 4.37668519,11.6372185 4.42312963,11.5555889 L5.82983333,9.11936667 C5.90372222,8.9919963 6.06627778,8.95047778 6.19083333,9.02295926 L7.09016667,9.54229259 L5.14724074,6.55295926 L1.5857963,6.36436667 Z M9.27938889,16.2302926 L5.88753704,16.2302926 C5.03183333,16.2302926 4.23453704,15.7700704 3.80598148,15.0290704 L1.33598148,10.7498481 C0.90812963,10.0088481 0.90812963,9.0884037 1.33598148,8.3467 L1.99253704,7.20881111 L0.369092593,6.27077407 C0.262833333,6.21025556 0.21287037,6.08429259 0.248055556,5.96747778 C0.282537037,5.85066296 0.397240741,5.77044074 0.514759259,5.77888519 L5.30838889,6.03292222 C5.39283333,6.03784815 5.47024074,6.08218148 5.51598148,6.15255185 L8.13305556,10.1770333 C8.1992037,10.2790704 8.18724074,10.4141815 8.1035,10.5021444 C8.01905556,10.5915148 7.88535185,10.6098111 7.7797963,10.5492926 L6.15564815,9.61195926 L5.10924074,11.4232926 L9.27938889,11.4232926 C9.42505556,11.4232926 9.54327778,11.5415148 9.54327778,11.6871815 L9.54327778,15.9664037 C9.54327778,16.1120704 9.42505556,16.2302926 9.27938889,16.2302926 Z", id: "Fill-6" }), (0,jsx_runtime.jsx)("path", { d: "M16.5924185,11.9517037 L15.3574185,11.9517037 C15.2117519,11.9517037 15.0935296,11.8334815 15.0935296,11.6878148 C15.0935296,11.5421481 15.2117519,11.4239259 15.3574185,11.4239259 L16.5924185,11.4239259 C17.2602333,11.4239259 17.8830111,11.0643333 18.2165667,10.4858889 C18.2904556,10.3599259 18.4516037,10.317 18.576863,10.3894815 C18.7035296,10.461963 18.7471593,10.6231111 18.6739741,10.7497778 C18.2461222,11.4914815 17.4488259,11.9517037 16.5924185,11.9517037", id: "Fill-8" }), (0,jsx_runtime.jsx)("path", { d: "M10.6638556,13.8271444 L12.280263,17.0050704 L12.280263,15.9664037 C12.280263,15.820737 12.3984852,15.7025148 12.5441519,15.7025148 L14.1225593,15.7025148 C14.7896704,15.7025148 15.4124481,15.3429222 15.7474111,14.7644778 L18.2160037,10.4859593 C18.550263,9.90751481 18.550263,9.18903333 18.2160037,8.61058889 L16.6523741,5.90132963 L13.4047815,7.7767 L15.586263,11.5555889 C15.6334111,11.6379222 15.6334111,11.7378481 15.586263,11.8194778 C15.5391148,11.9018111 15.4518556,11.9517741 15.3575593,11.9517741 L12.5441519,11.9517741 C12.3984852,11.9517741 12.280263,11.8335519 12.280263,11.6878852 L12.280263,10.6492185 L10.6638556,13.8271444 Z M12.5441519,18.3695519 C12.446337,18.3695519 12.3541519,18.3153667 12.3091148,18.2252926 L10.1325593,13.9467741 C10.0938556,13.8714778 10.0938556,13.7828111 10.1325593,13.7075148 L12.3091148,9.4289963 C12.3633,9.31921852 12.4885593,9.26292222 12.6060778,9.29177407 C12.7243,9.31992222 12.8080407,9.42618148 12.8080407,9.54792222 L12.8080407,11.4239963 L14.9008556,11.4239963 L12.8150778,7.81258889 C12.7805963,7.75207037 12.7707444,7.67958889 12.7890407,7.61203333 C12.8066333,7.54447778 12.8509667,7.48677407 12.9114852,7.45158889 L16.6171889,5.31232963 C16.740337,5.23984815 16.9028926,5.28207037 16.9781889,5.40944074 L18.6741148,8.3467 C19.101263,9.0884037 19.101263,10.0088481 18.6741148,10.7498481 L16.2041148,15.0290704 C15.7755593,15.7700704 14.9775593,16.2302926 14.1225593,16.2302926 L12.8080407,16.2302926 L12.8080407,18.105663 C12.8080407,18.2274037 12.7243,18.333663 12.6060778,18.3625148 C12.5849667,18.3674407 12.5645593,18.3695519 12.5441519,18.3695519 Z", id: "Fill-10" }), (0,jsx_runtime.jsx)("path", { d: "M10.004837,2.68054815 C9.91405926,2.68054815 9.82539259,2.6334 9.77613333,2.54895556 L9.15828148,1.47862222 C8.82472593,0.900881481 8.20194815,0.541288889 7.53413333,0.541288889 C7.38846667,0.541288889 7.27024444,0.423066667 7.27024444,0.2774 C7.27024444,0.131733333 7.38846667,0.0135111111 7.53413333,0.0135111111 C8.38983704,0.0135111111 9.18783704,0.473733333 9.61568889,1.21473333 L10.2335407,2.28506667 C10.3067259,2.41102963 10.2630963,2.57217778 10.1364296,2.64536296 C10.0956148,2.66928889 10.0498741,2.68054815 10.004837,2.68054815", id: "Fill-12" }), (0,jsx_runtime.jsx)("path", { d: "M4.34698889,4.18795185 L7.59458148,6.06332222 L9.77606296,2.28443333 C9.87106296,2.12117407 10.1384704,2.12117407 10.2334704,2.28443333 L11.6401741,4.72135926 C11.6746556,4.78187778 11.6845074,4.85365556 11.6662111,4.92121111 C11.6486185,4.98947037 11.6042852,5.04647037 11.5437667,5.08165556 L10.6437296,5.60098889 L14.2051741,5.41169259 L16.1488037,2.42306296 L15.2487667,2.9423963 C15.1882481,2.97687778 15.115063,2.98602593 15.0489148,2.96913704 C14.9806556,2.95084074 14.9229519,2.90650741 14.8877667,2.84598889 L14.0989148,1.47869259 C13.766063,0.900951852 13.1432852,0.541359259 12.4754704,0.541359259 L7.53406296,0.541359259 C6.86695185,0.541359259 6.24417407,0.900951852 5.90991481,1.4793963 L4.34698889,4.18795185 Z M7.69169259,6.68750741 C7.64524815,6.68750741 7.60021111,6.67554444 7.5593963,6.65232222 L3.8543963,4.51306296 C3.72772963,4.43987778 3.6848037,4.27872963 3.75728519,4.15276667 L5.45250741,1.2148037 C5.88176667,0.473803704 6.67906296,0.0135814815 7.53406296,0.0135814815 L12.4754704,0.0135814815 C13.3311741,0.0135814815 14.1284704,0.473803704 14.5570259,1.2148037 L15.2135815,2.3533963 L16.8377296,1.41606296 C16.9432852,1.35484074 17.0769889,1.37313704 17.1614333,1.46250741 C17.2451741,1.55117407 17.2578407,1.68558148 17.1909889,1.78832222 L14.5739148,5.8121 C14.5281741,5.88247037 14.4507667,5.92750741 14.3663222,5.93172963 L9.57269259,6.18647037 C9.45165556,6.19421111 9.34047037,6.1153963 9.30598889,5.99787778 C9.2708037,5.88106296 9.32076667,5.7551 9.42702593,5.69458148 L11.0504704,4.75654444 L10.0047667,2.94450741 L7.9203963,6.55591481 C7.88521111,6.61643333 7.82750741,6.66076667 7.75995185,6.67906296 C7.73743333,6.68469259 7.71421111,6.68750741 7.69169259,6.68750741 Z", id: "Fill-14" })] }))] })) })) })) }))] })));
};

})();

var __webpack_exports__IconBenefitsRecycledmaterial = __webpack_exports__.u;
export { __webpack_exports__IconBenefitsRecycledmaterial as IconBenefitsRecycledmaterial };
